// https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api/property-expansion-and-limiting

// When retrieving the descendants of a page item, use the following expand query.
// There's a bug in the API that causes the JSON response to be invalid
// when using the EXPAND_CONTENT query for descendants.
export const EXPAND_CONTENT_DESCENDANTS = `properties[
  hero[$all],
  secondaryHero[$all],
  uniqueSellingPoints[$all],
  headerAfbeelding[$all],
  campagneblokV2[$all],
  topLinks[$all],
  links[$all],
  interneLinkMetIcoon[$all],
  externeLinkMetIcoon[$all],
  bestand[$all],
  afbeeldingen[$all],
  link[$all],
  afbeelding[$all],
  image[$all],
  image[$all[properties[$all]]],
  accordionItems[$all[properties[$all]]],
]`
  .replaceAll('\n', '')
  .replaceAll(' ', '');

// Above query is used for descendants, this query is used for single page items.
// This will expand all deeply nested properties of the page item.
// Important: "marketingblokken" and "campagneblokV2" have to be expanded separately
// and above the "all" property so nested media and block-list properties are included.
export const EXPAND_CONTENT = `properties[
  marketingblokken[$all[properties[$all]]],
  campagneblokV2[$all[properties[$all]]],
  $all[
    ${EXPAND_CONTENT_DESCENDANTS}
  ]
]`
  .replaceAll('\n', '')
  .replaceAll(' ', '');

// `tags` on nieuwbouwDetailPagina is a block-list; items expose tagNaam via
// content.properties, so it needs the deep expand to survive the projection.
export const EXPAND_CHILDREN_TILE = 'properties[headerAfbeelding[$all],redirect[$all],tags[$all[properties[$all]]]]';

export const FIELDS_CHILDREN_TILE = 'properties[titel,introductieTekst,headerAfbeelding,toonOpBovenliggendeOverzichtPagina,redirect,icoon,buurt,tags,longitude,latitude]';
